var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("verifications.dtls") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _vm.activateSpinner
            ? _c("spinner")
            : _c(
                "div",
                { staticClass: "px-3" },
                [
                  _c(
                    "b-row",
                    {},
                    [
                      _c(
                        "b-col",
                        { staticClass: "p-0", attrs: { cols: "2" } },
                        [
                          _c("back-button", {
                            attrs: { returnUrl: _vm.returnUrl },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.companyItems.length > 0
                    ? _c(
                        "div",
                        [
                          _c("b-row", { staticClass: "title-label-blue" }, [
                            _c("span", { staticClass: "text-center mx-auto" }, [
                              _vm._v(
                                _vm._s(_vm.$t("verifications.company_data"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "justify-content-start" },
                            [
                              _c("b-table", {
                                staticClass: "table",
                                attrs: {
                                  items: _vm.companyItems,
                                  fields: _vm.scoreFields,
                                  "tbody-tr-class": _vm.rowClass,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "cell(score)",
                                      fn: function (data) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "text-center" },
                                            [
                                              data.value === "KO"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa-light fa-xmark btn btn-icon btn-icon-red",
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              data.value === "OK"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa-light fa-check btn btn-icon btn-icon-green",
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2443103388
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.etabItems.length > 0
                    ? _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _c("b-row", { staticClass: "title-label-blue" }, [
                            _c("span", { staticClass: "text-center mx-auto" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("verifications.company_building_data")
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "justify-content-start" },
                            [
                              _c("b-table", {
                                staticClass: "table",
                                attrs: {
                                  items: _vm.etabItems,
                                  fields: _vm.scoreFields,
                                  "tbody-tr-td-class": _vm.rowClass,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "cell(score)",
                                      fn: function (data) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "text-center" },
                                            [
                                              data.value === "KO"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa-light fa-xmark btn btn-icon btn-icon-red",
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              data.value === "OK"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fa-light fa-check btn btn-icon btn-icon-green",
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2443103388
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.note
                    ? _c(
                        "div",
                        [
                          _c("b-row", { staticClass: "title-label-blue" }, [
                            _c("span", { staticClass: "text-center mx-auto" }, [
                              _vm._v(_vm._s(_vm.$t("common.comment_label"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "justify-content-start" },
                            [
                              _c("b-table", {
                                staticClass: "resultsVerifications",
                                attrs: {
                                  hover: "",
                                  bordered: "",
                                  "head-variant": "light",
                                  items: _vm.noteItems,
                                  fields: _vm.noteFields,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.entity.getUBOs
                    ? _c(
                        "div",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            title: _vm.$t("verification.effective_bnf"),
                          },
                        },
                        [
                          _c("b-row", { staticClass: "title-label-blue" }, [
                            _c("span", { staticClass: "text-center mx-auto" }, [
                              _vm._v(
                                _vm._s(_vm.$t("verification.effective_bnf"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.ubos.length
                            ? _c(
                                "b-row",
                                { staticClass: "justify-content-start" },
                                _vm._l(_vm.ubos, function (ubo, index) {
                                  return _c(
                                    "b-col",
                                    {
                                      key: index,
                                      staticClass: "form-group",
                                      attrs: { sm: "6" },
                                    },
                                    [
                                      ubo.Type === "PP"
                                        ? _c("i", {
                                            staticClass: "fa-light fa-user",
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      ubo.Type === "PM"
                                        ? _c("i", {
                                            staticClass: "fa-light fa-building",
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(ubo.LastName) +
                                          "\n            " +
                                          _vm._s(ubo.FirstName) +
                                          "\n            " +
                                          _vm._s(
                                            ubo.PercentageDetention + "%"
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.verificationsItems.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "mt-3 p-0",
                          attrs: {
                            title: _vm.$t("verifications.verification_title"),
                            isTitleUpperCase: false,
                          },
                        },
                        [
                          _c("b-row", { staticClass: "title-label-blue" }, [
                            _c("span", { staticClass: "text-center mx-auto" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("verifications.verification_title")
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "justify-content-start" },
                            [
                              _c("b-table", {
                                staticClass: "table",
                                attrs: {
                                  items: _vm.verificationsItems,
                                  fields: _vm.verificationsFields,
                                  "sort-by": "id",
                                  "tbody-tr-td-class": _vm.rowClass,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "cell(result)",
                                      fn: function (data) {
                                        return [
                                          data.value === "KO"
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-light fa-xmark btn btn-icon btn-icon-red",
                                              })
                                            : data.value === "WARN"
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-light fa-warning btn btn-icon btn-icon-orange",
                                              })
                                            : data.value === "INFO"
                                            ? _c("i", {
                                                staticClass:
                                                  "fa-light fa-circle-info btn btn-icon btn-icon-orange",
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "fa-light fa-check btn btn-icon btn-icon-green",
                                              }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1255921075
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-row", { staticClass: "title-label-blue" }, [
                    _c("span", { staticClass: "text-center mx-auto" }, [
                      _vm._v(_vm._s(_vm.$t("verifications.stat_global"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-row", { staticClass: "justify-content-start" }, [
                    _c("table", { staticClass: "table" }, [
                      _c("thead", [
                        _c("th", { attrs: { width: "20%" } }, [
                          _vm._v(_vm._s(_vm.$t("verifications.desc"))),
                        ]),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "20%" } }, [
                          _vm._v(_vm._s(_vm.$t("verifications.stat_global"))),
                        ]),
                        _vm._v(" "),
                        _c("th", { attrs: { width: "40%" } }, [
                          _vm._v(_vm._s(_vm.$t("verifications.action"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.globalStatus === "1"
                        ? _c("tbody", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.$t("verifications.stat_ok"))),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("i", {
                                staticClass:
                                  "fa-light fa-check btn btn-icon btn-icon-green",
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary", size: "lg" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createSupplier()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-light fa-plus",
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("verifications.add_supplier")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.globalStatus === "3"
                        ? _c("tbody", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.$t("verifications.stat_warn"))),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("i", {
                                staticClass:
                                  "fa-light fa-warning btn btn-icon btn-icon-orange",
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary", size: "lg" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createSupplier()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-light fa-plus",
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("verifications.add_supplier")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.globalStatus === "4"
                        ? _c("tbody", [
                            _c("td", [
                              _vm._v(_vm._s(_vm.$t("verifications.stat_ko"))),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("i", {
                                staticClass:
                                  "fa-light fa-xmark btn btn-icon btn-icon-red",
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary", size: "lg" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.createSupplier()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-light fa-plus",
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("verifications.add_supplier")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ],
                1
              ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }